import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import studentAuthService from '../../../services/studentAuth';

const StudentProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = studentAuthService.isAuthenticated();
  const mustChangePassword = studentAuthService.mustChangePassword();
  const userType = localStorage.getItem('userType');

  // Must be authenticated AND be student userType
  if (!isAuthenticated || userType !== 'student') {
    return <Navigate to="/student/login" replace />;
  }

  // If user must change password and is not on the change-password page, redirect
  if (mustChangePassword && location.pathname !== '/student/change-password') {
    return <Navigate to="/student/change-password" state={{ firstLogin: true }} replace />;
  }

  return children;
};

export default StudentProtectedRoute;
